import React, { createContext, useContext, useState } from 'react';
import { useAdmin } from './AdminContext';

const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const { allProducts } = useAdmin();
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [isSearchOpen, setIsSearchOpen] = useState(false);

  const performSearch = (query) => {
    setSearchQuery(query);
    if (!query.trim()) {
      setSearchResults([]);
      return;
    }
    const lowerQuery = query.toLowerCase();
    const results = allProducts.filter(product =>
      product.name.toLowerCase().includes(lowerQuery) ||
      product.category.toLowerCase().includes(lowerQuery) ||
      (product.fabric || '').toLowerCase().includes(lowerQuery) ||
      (product.pattern || '').toLowerCase().includes(lowerQuery) ||
      (product.occasion || '').toLowerCase().includes(lowerQuery) ||
      product.description.toLowerCase().includes(lowerQuery)
    );
    setSearchResults(results);
  };

  const getSuggestions = (query) => {
    if (!query.trim()) return [];
    const lowerQuery = query.toLowerCase();
    const suggestions = new Set();
    allProducts.forEach(product => {
      if (product.name.toLowerCase().includes(lowerQuery)) {
        suggestions.add(product.name);
      }
      if (product.category.toLowerCase().includes(lowerQuery)) {
        suggestions.add(product.category);
      }
    });
    return Array.from(suggestions).slice(0, 5);
  };

  return (
    <SearchContext.Provider value={{
      searchQuery,
      searchResults,
      isSearchOpen,
      setIsSearchOpen,
      performSearch,
      getSuggestions,
      setSearchQuery
    }}>
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) throw new Error('useSearch must be used within SearchProvider');
  return context;
};
